module.exports = __webpack_public_path__ + "img/select.128ed159.svg";